import onCustomisation from "@sections/customisations_data";

const headers = document.querySelectorAll(".header-mutual");

function showCustomHeader(_data) {
  var logo = document.querySelector(".logo svg");
  headers.forEach((header) => {
    header.classList.add('custom-header');
    header.innerHTML = logo.outerHTML;
  })
};

function fixFooter(){
  $('.footer-logo').addClass('pb-16');
  $('.footer-custo-hidden-elt').addClass('hidden md:hiden lg:hidden');
}

// Hiding the footer always go with a custom header hiding usual navigation
onCustomisation('hide_footer', (data) => {
  if (data.no_footer) {
    showCustomHeader(data);
    fixFooter();
  }
});
